import React from 'react';
import { Text } from '../../ui/typography/Text';
import { Coins } from 'lucide-react';

interface CoinFlipsProps {
  currentFlip: boolean | null;
  flips: boolean[];
  maxFlips: number;
}

export const CoinFlips: React.FC<CoinFlipsProps> = ({ currentFlip, flips, maxFlips }) => {
  return (
    <div className="space-y-6">
      {/* Progress and current flip */}
      <div className="flex flex-col items-center gap-4">
        <div className="[perspective:1000px]"> {/* 3D container */}
          <div 
            className={`w-20 h-20 rounded-full bg-gradient-to-br from-blue-50 to-blue-100 
              border-2 border-blue-200 shadow-lg 
              relative [transform-style:preserve-3d]
              ${currentFlip !== null ? 'animate-continuous-flip' : ''}`}
          >
            {/* Front side */}
            <div className="absolute inset-0 flex items-center justify-center [backface-visibility:hidden]">
              <span className="text-3xl font-bold text-blue-700">
                H
              </span>
            </div>
            
            {/* Back side */}
            <div className="absolute inset-0 flex items-center justify-center [transform:rotateY(180deg)] [backface-visibility:hidden]">
              <span className="text-3xl font-bold text-blue-700">
                T
              </span>
            </div>

            {/* Initial state */}
            {currentFlip === null && (
              <div className="absolute inset-0 flex items-center justify-center">
                <Coins className="w-8 h-8 text-blue-400 animate-pulse" />
              </div>
            )}
          </div>
        </div>
        <div className="text-center">
          <Text size="lg" className="font-medium text-gray-800">
            Flip {flips.length} of {maxFlips}
          </Text>
          <div className="w-48 h-1.5 bg-gray-100 rounded-full mt-2">
            <div 
              className="h-full bg-blue-500 rounded-full transition-all duration-200"
              style={{ width: `${(flips.length / maxFlips) * 100}%` }}
            />
          </div>
        </div>
      </div>

      {/* Recent flips history */}
      <div className="space-y-2">
        <Text className="text-sm text-gray-600 text-center">Last 10 flips:</Text>
        <div className="flex gap-1.5 justify-center">
          {flips.slice(-10).map((flip, i) => (
            <span
              key={i}
              className={`w-8 h-8 flex items-center justify-center rounded-lg 
                font-medium text-sm transition-all duration-300
                transform hover:scale-110
                ${flip 
                  ? 'bg-blue-100 text-blue-700 border border-blue-200' 
                  : 'bg-orange-100 text-orange-700 border border-orange-200'
                }`}
            >
              {flip ? 'H' : 'T'}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}; 